import codeEditorService from '@/services/embeds/plugin/code.editor.service'
import { useEmbedConfigureStore } from '@/stores/embeds/embedConfigure.store'
import { useIdeStore } from '@/stores/embeds/ide.store'

/**
 * post to jdoodle
 */
const postToJDoodle = async () => {
  const languageMeta = useEmbedConfigureStore().getLanguageMeta
  const selectedLanguage = useIdeStore().selectedLanguage

  if (!selectedLanguage || !selectedLanguage?.language) return
  const languageMetaItem: any = languageMeta[selectedLanguage?.language]

  const canonicalPath = languageMetaItem.canonicalPath

  if (!canonicalPath) return

  let postUrl: string = ''
  //@ts-ignore
  if (process.env.NODE_ENV === 'development') {
    postUrl = `${import.meta.env.VITE_APP_IP}:${
      import.meta.env.VITE_APP_PORT
    }/api/redirect-to-post/${canonicalPath}`
  } else {
    postUrl = `https://www.jdoodle.com/api/redirect-to-post/${canonicalPath}`
  }
  const form = document.createElement('form')
  form.method = 'POST'
  form.action = postUrl
  form.target = '_blank'
  const input = document.createElement('input')
  input.type = 'hidden'
  input.id = 'initScriptForPost'
  input.name = 'initScript'
  input.value = codeEditorService.getScript()
  form.appendChild(input)
  document.body.appendChild(form)
  form.submit()
  await new Promise((resolve) => setTimeout(resolve, 1000))
  document.body.removeChild(form)
}

export default { postToJDoodle }
